import userGWFragments from '@shared/hooks/usegwFragments'
import { http } from '../http'
import { AsanSignRequest, AsanSignResponse } from 'store/reducers/ibsigning/asansigning/sign/types'
import { AsanAdocResponse, AsanVerifyRequest, AsanVerifyResponse } from 'store/reducers/ibsigning/asansigning/verify/types'

export const asanSigning = async (requestBody: AsanSignRequest): Promise<AsanSignResponse> => {
  const userFragments = userGWFragments()

  const { data } = await http.post<any>(
    `gateway/${userFragments.customerNo}/inquiry`,
    {
      url: '/ib/signing/asan/sign',
      data: requestBody,
    }
  )

  if (data.data.code !== 200) {
    throw new Error(data.data.message)
  }

  return data.data.data
}

export const asanSigningVerify = async (requestBody: AsanVerifyRequest): Promise<AsanVerifyResponse> => {
  const userFragments = userGWFragments()

  const { data } = await http.post<any>(
    `gateway/${userFragments.customerNo}/inquiry`,
    {
      url: '/ib/signing/asan/verify',
      data: requestBody,
    }
  )

  if (data.data.code !== 200) {
    throw new Error(data.data.message)
  }

  return data.data.data
}

export const asanSigningAdocFile = async (requestBody: AsanVerifyRequest): Promise<AsanAdocResponse> => {
  const userFragments = userGWFragments()

  const { data } = await http.post<any>(
    `gateway/${userFragments.customerNo}/inquiry`,
    {
      url: '/ib/signing/asan/adoc',
      data: requestBody,
    }
  )

  if (data.data.code !== 200) {
    throw new Error(data.data.message)
  }

  return data.data.data
}
